import { HomeHeroSlide } from '@/screens/Home'

export const getBannerClick = (slide: HomeHeroSlide, index: string) => {
	return {
		ecommerce: {
			promoClick: {
				promotions: [
					{
						id: slide.ID,
						name: slide.NAME,
						position: index
					}
				]
			}
		}
	}
}
